import React, {
  Component,
} from "react";

import store from "CommonState/store";
import apifetch from "CommonCore/apifetch";
import {
  asyncDebounce,
} from "CommonState/action-helpers";

@store
export default class ApiController extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    delete this.__unmounted;
    this.apiUpdate = asyncDebounce(this.props.name, this.props.dispatch);
    this.update(this.props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.payload && (prevProps.payload !== this.props.payload || prevProps.forceUpdate)) {
      this.update(this.props);
    }
    if (this.props.url && prevProps.url !== this.props.url) {
      this.update(this.props);
    }
  }

  componentWillUnmount() {
    this.__unmounted = true;
  }

  update(props) {
    const { array, url, payload, toBody, method = payload ? "POST" : "GET", validate } = props;
    let data;

    this.apiUpdate(async() => {
      if (validate && !validate(payload)) {
        this.setState({
          data: undefined,
        });
        return;
      }

      this.setState({ inflight: true });
      try {
        data = await apifetch(url, { method, body: toBody ? toBody(payload) : payload });
      } catch(err) {
        this.setStateAsync({
          data: undefined,
          inflight: false,
          errorMessage: (err.response && (err.response.nachricht || err.response.um)) || "Es ist ein Fehler aufgetreten.",
        });
        return;
      }

      // unpack in case of single array wrapped in object
      if (array) {
        data = data.data;
      }

      this.setStateAsync({
        data,
        inflight: false,
        errorMessage: undefined,
      });
    });
  }

  setStateAsync = state => {
    if (!this.__unmounted) {
      this.setState(state);
      const { onNewResult } = this.props;
      if (onNewResult) {
        onNewResult(state);
      }
    } else {
      this.state = state;
    }
  };

  render() {
    const child = React.Children.toArray(this.props.children)[0];
    return React.cloneElement(child, this.state);
  }
}
